<div style="display: block">
    <section class="content">
        <div class="form-group">
            <label class="font-weight-bold">{{ 'daily_meals' | localise }}</label>

            <div class="form-check" *ngFor="let item of dailyMeals">
                <label class="form-check-label">
                    <input type="radio"
                           class="form-check-input"
                           name="dailyMeals"
                           id="dailyMeals{{ item.id }}"
                           value="{{ item.id }}"
                           (input)="currentlySelectedDailyMeal = item"
                           [checked]="currentlySelectedDailyMeal?.id == item.id"/>
                    {{ item.title }}
                    <i class="input-helper"></i>
                </label>
            </div>
        </div>


        <div class="form-group">
            <label class="font-weight-bold">{{ 'diet' | localise }}</label>

            <div class="form-check">
                <label class="form-check-label">
                    <input type="radio"
                           class="form-check-input"
                           name="diets"
                           id="diets0"
                           value=""
                           (input)="currentlySelectedDiet = null"
                           [checked]="!currentlySelectedDiet"/>
                    {{ 'no_diet_chosen' | localise }}
                    <i class="input-helper"></i>
                </label>
            </div>

            <div class="form-check" *ngFor="let item of diets">
                <label class="form-check-label">
                    <input type="radio"
                           class="form-check-input"
                           name="diets"
                           id="diets{{ item.id }}"
                           value="{{ item.id }}"
                           (input)="currentlySelectedDiet = item"
                           [checked]="currentlySelectedDiet?.id == item.id"/>
                    {{ item.title }}
                    <i class="input-helper"></i>
                </label>
            </div>
        </div>
        <div class="form-group">
            <label class="font-weight-bold">{{ 'allergens' | localise }}</label>
            <div class="form-check" *ngFor="let allergy of allergies">
                <label class="form-check-label">
                    <input
                            type="checkbox"
                            class="form-check-input"
                            name="allergies"
                            (input)="enabledByAllergy[allergy.id] = !enabledByAllergy[allergy.id]"
                            [checked]="enabledByAllergy[allergy.id]"
                    />
                    {{ allergy.title }}
                    <i class="input-helper"></i>
                </label>
            </div>
        </div>
        <div class="mt-4" *ngIf="editable">
            <button class="btn btn-block btn-primary" (click)="updateProfile()"
                    [disabled]="saveButtonIsDisabled">{{ 'save' | localise }}</button>
        </div>
    </section>
</div>
